<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="服务分类" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="fuwu-class">
        <mt-navbar v-model="selected" class="tab-nav">
            <mt-tab-item :id="'container_'+ index"  v-for="(item, index) in fuwuClassList" :key="item.categoryName">{{item.o2o_fuwu_class_name}}</mt-tab-item>
        </mt-navbar>
        <mt-tab-container v-model="selected" class="tab-container">
            <mt-tab-container-item :id="'container_' + index" v-for="(item, index) in fuwuClassList">
                <div v-for="(i, index) in item.child" @click="goFuwuGoodsList(i.o2o_fuwu_class_id)" class="class-wrap">
                    <div class="p_img" :style="{backgroundImage:'url('+i.o2o_fuwu_class_logo_url+')'}"></div>
                    <div class="p_info">{{i.o2o_fuwu_class_name}}</div>
										<div class="p_desc">{{i.o2o_fuwu_class_remark}}</div>
                </div>
            </mt-tab-container-item>
        </mt-tab-container>
        </div>
    </div>
</template>

<script>
import { Indicator, Toast } from 'mint-ui'
import { getClassTree } from '../../../api/fuwuClass'
export default {
  data () {
    return {
      selected: 'container_0',
      fuwuClassList: []
    }
  },
  computed: {

  },
  created () {
    this.getFuwuClassList()
  },
  methods: {
    getFuwuClassList () {
      Indicator.open()
      getClassTree().then(res => {
        Indicator.close()
        this.fuwuClassList = res.result.o2o_fuwu_class_list
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    },
    goFuwuGoodsList (o2o_fuwu_class_id) {
      this.$router.push({ name: 'FuwuOrganizationList', query: { class_id: o2o_fuwu_class_id } })
    }
  }
}
</script>

<style lang="css">
    .fuwu-class .mint-tab-item-label{
        font-size:0.6rem;
    }
    .fuwu-class .mint-navbar .mint-tab-item{
        height:1rem;
        line-height:1rem;
        border-left:0.1rem solid transparent;
    }
    .fuwu-class .mint-navbar{
        height: 100%;
    }
    .fuwu-class .mint-tab-container-wrap{
        position: relative;
        width: 100%;
    }
    .fuwu-class .mint-navbar .mint-tab-item.is-selected{
        border-left:0.1rem solid #d60e19;
        color: #d60e19;
        background: #fff;
        border-bottom:none;
    }
    .fuwu-class .mint-tab-container-item{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin-top:0;
    }
</style>
<style lang="scss" scoped>
    .container{
        background:#fff;
        .fuwu-class{
            margin-top:0;
            display: flex;
            flex-direction: row;
            height: 100%;
            width: 100%;
            .tab-nav{
                flex: 25%;
                height:100%;
                display: flex;
                flex-direction: column;
                background: #fafafa;
                .tab-item{
                    flex: 1;
                    height: 120px;
                    width: 100%;
                    box-sizing: border-box;
                }
            }
            .tab-container{
                flex: 75%;
                height:100%;
                font-size:0.8rem;
                position: relative;
                .class-wrap{
                    width:100%;
                    height:2.5rem;
                    border-bottom: 1px solid #e6e6e6;
                    padding:0.5rem 0;
                    .p_img{
                        width:5.2rem;
                        height:2.5rem;
                        float:left;
												background-size:cover;
                        background-position:center;
                    }
                    .p_info{
                        margin-left: 5.5rem;
												font-size:.7rem;
												margin-bottom:.2rem;
												margin-top:.2rem;
                    }
										.p_desc{
												font-size:.6rem;
												color:#999;
                        margin-left: 5.5rem;
												display: -webkit-box;
												-webkit-line-clamp: 2;
												-webkit-box-orient: vertical;
												line-clamp: 2;
												box-orient: vertical;
												line-height:1.2;
												height:1.44rem;
												overflow:hidden;
                    }
                }
            }
        }
    }

</style>
